import { render, staticRenderFns } from "./SchoolTitle.vue?vue&type=template&id=201e019e&"
import script from "./SchoolTitle.vue?vue&type=script&lang=js&"
export * from "./SchoolTitle.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTitle.vue?vue&type=style&index=0&id=201e019e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports